import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, config } from 'rxjs';
import { ConfigService } from '../../../../shared/services/config.service';
import { UserService } from '../../../../shared/services/user.service';
import { CodesAndAttributesDto } from "../models/codes-and-attributes.model";
import { DocumentVersion } from "../models/document-version.model";

@Injectable({
  providedIn: 'root'
})
export class DocumentQueueService {

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) {
  }

  private get httpOptions() {
    let sessionId = "";
    if (typeof (this.userService) !== "undefined" && this.userService != null && typeof (this.userService.sessionId) !== "undefined" && this.userService != null) {
      sessionId = this.userService.sessionId;
    }
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-document-key',
        'SessionId': sessionId
      })
    };
  }

  getDocumentQueue(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentQueue/GetAll`, this.httpOptions);
  }

  deleteDocumentQueue(documentQueueId: number): Observable<any> {
    return this.http.delete<any>(this.configService.config.documentUrl + `/api/DocumentQueue/DeleteDocumentQueue?documentQueueId=${documentQueueId}`, this.httpOptions);
  }

  getStatuses(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/GetDocumentStatuses`, this.httpOptions);
  }

  getTypes(SessionId: string = null): Observable<any> {
    let languageId = this.userService.languageId;
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentQueue/GetDocumentTypes/${languageId}?SessionId=${(SessionId ?? "")}`, this.httpOptions);
  }

  getDocumentQueueById(documentId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentQueue/GetVersionsForCurrentDocument/${documentId}`, this.httpOptions);
  }

  getCategories() {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentCard/GetDocumentCategories`, this.httpOptions);
  }

  updateDocumentQueueProperties(value: any): Observable<any> {
    return this.http.patch<any>(this.configService.config.documentUrl + `/api/DocumentQueue/UpdateDocumentQueue${value}`, this.httpOptions);
  }

  getPreviousDocumentsByFilter(filterData): Observable<any> {
    let parameters: string = '';
    parameters += '?Type=' + filterData.Type;
    if (filterData.Category != null) parameters += '&Category=' + filterData.Category;
    if (filterData.Status != null) parameters += '&Status=' + filterData.Category;
    if (filterData.Name != null) parameters += '&Name=' + filterData.Name;
    if (filterData.FileName != null) parameters += '&FileName=' + filterData.FileName;
    if (filterData.FreeSearch != '') parameters += '&FreeSearch=' + filterData.FreeSearch;
    if (filterData.Codes) {
      filterData.Codes.forEach(function (value) {
        parameters += '&Codes=' + value;
      });
    }

    if (filterData.AttributeValues) {
      filterData.AttributeValues.forEach(function (value) {
        parameters += '&AttributeValues=' + value;
      });
    }

    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentQueue/SearchPreviousVersionsByFilter` + parameters, this.httpOptions);
  }

  AddNewDocumentCard(value: CodesAndAttributesDto): Observable<any> {
    let x = this.http.post<any>(this.configService.config.documentUrl + `/api/DocumentQueue/AddNewDocumentCard/`, value, this.httpOptions);
    
    return x;
  }

  getLanguages(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentAdmin/GetLanguages`, this.httpOptions);
  }
  
}

